export const HOME = '/';
export const NOT_FOUND = '/404';